import { schema } from 'normalizr';

export const roundSchema = new schema.Entity('round', {}, { idAttribute: '_id' });
export const roundListSchema = [roundSchema];
